import React from 'react';

const ButtonWithIcon = ({ 
  children, 
  onClick, 
  className = '', 
  disabled = false,
  type = 'button',
  iconLeft: IconLeft,
  iconRight: IconRight,
  iconLeftClassName = 'icon-left',
  iconRightClassName = 'icon-right',
  href,
  target,
  rel,
  ...props 
}) => {
  const baseClasses = 'btn';
  const combinedClasses = `${baseClasses} ${className}`.trim();

  const buttonContent = (
    <>
      {IconLeft && <IconLeft className={iconLeftClassName} />}
      {children && <span className="text">{children}</span>}
      {IconRight && <IconRight className={iconRightClassName} />}
    </>
  );

  // If href is provided, render as anchor tag
  if (href) {
    return (
      <a
        href={href}
        className={combinedClasses}
        onClick={onClick}
        target={target}
        rel={rel}
        {...props}
      >
        {buttonContent}
      </a>
    );
  }

  // Otherwise render as button
  return (
    <button
      type={type}
      className={combinedClasses}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {buttonContent}
    </button>
  );
};

export default ButtonWithIcon;
